var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payload)?_c('div',[(_vm.payload.fullView)?_c('Filterable',{attrs:{"items":_vm.items,"payload":_vm.payload}}):_c('Simple',{attrs:{"items":_vm.items,"payload":_vm.payload}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }